module.exports = __webpack_public_path__ + "static/media/GCP_firstPage_en.6c0af689.png";